export default __webpack_public_path__ + "static/media/icon_entry.684e4721.svg";